import { render, staticRenderFns } from "./TwoPanelPage.vue?vue&type=template&id=53f4a56e&scoped=true&"
import script from "./TwoPanelPage.vue?vue&type=script&lang=js&"
export * from "./TwoPanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4a56e",
  null
  
)

export default component.exports